<script context="module">
  import { urlServeur } from "../components/conf.js";
  import CardProgress from "../components/ihm/CardProgress.svelte";
  import CardPrix from "../components/ihm/CardPrix.svelte";

  let rows;
  let totalLoyersTheo = 99;
  let totalLoyersPercus = 88;
  let totalHonoraires = 0;
  let tabKeys;
  let percentRealise;

  const fecthData = async () => {
    const response = await fetch(urlServeur + "/api/immeubles/recaployers");

    if (response.ok) {
      const result = await response.json();
      const payload = result.payload;

      tabKeys = Object.keys(payload.immos); // Nom des appt
      rows = Object.values(payload.immos); // tableau des monants

      totalLoyersTheo = payload.totalLoyerTheorique;
      totalLoyersPercus = payload.totalLoyerPercus;
      totalHonoraires = payload.totalHonoraires;

      percentRealise = new Intl.NumberFormat("fr-FR").format(
        Math.round((totalLoyersPercus * 100) / totalLoyersTheo)
      );
      // console.log(rows);

      return rows;
    } else {
      throw new (error(text))();
    }
  };

  /**
   *
   * @param data
   */
  const totalLoyersMensuel = () => {
    let tot = parseFloat(0);

    rows.forEach((element) => {
      tot += parseFloat(element.loyerTheo);
    });

    return tot;
  };

  let promise = fecthData();
</script>

{#await promise}
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
{:then elements}
  <div class="row">
    <!--  Etat general -->
    <div class="col-lg-4 col-md-4 col-sm-12">
      <CardPrix
        cardTitle="Total loyers Mens."
        cardColor="green"
        cardPrix={new Intl.NumberFormat("fr-FR").format(totalLoyersMensuel())}
      />
    </div>

    <div class="col-lg-4 col-md-4 col-sm-12">
      <CardPrix
        cardTitle="Loyers théo."
        cardPrix={new Intl.NumberFormat("fr-FR").format(totalLoyersTheo)}
      />
    </div>

    <div class="col-lg-4 col-md-4 col-sm-12">
      <CardPrix
        cardTitle="Loyers perçus"
        cardPrix={new Intl.NumberFormat("fr-FR").format(totalLoyersPercus)}
      />
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12">
      <CardPrix
        cardTitle="% réalisé"
        cardPrix={totalLoyersPercus != 0
          ? new Intl.NumberFormat("fr-FR").format(
              (totalLoyersPercus * 100) / totalLoyersTheo
            ) + "%"
          : "-"}
      />
    </div>
    <div class="col-lg-4 col-md-4 col-sm-12">
      <CardPrix
        cardTitle="Honoraires"
        cardColor="orange"
        cardPrix={new Intl.NumberFormat("fr-FR").format(totalHonoraires)}
      />
    </div>
  </div>
  <!--  Detail par immo -->
  <div class="row">
    {#each elements as element, i}
      <div class="col-xl-3 col-lg-6">
        <CardProgress
          cardTitle={tabKeys[i]}
          cardNumber={element.loyerTheo}
          cardColor="cherry"
          cardPourcent={element.loyerTheo != 0
            ? (element.LOYER_MOIS * 100) / (element.loyerTheo * 12)
            : 0}
        />
      </div>
    {/each}
  </div>
{/await}
